import { useQuery } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'

// List all subscriptions
export function useSubscriptions() {
  return useQuery({
    queryKey: queryKeys.subscriptions.all,
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/subscriptions')
      if (error) throw error
      return data
    },
    staleTime: 30 * 1000,
  })
}
